import { ModuleSuggestionsVO } from '@/core/services/aiAssistant';

/**
 * 本地兜底气泡：后端 /chat/suggestions 没上线 / 调用失败时使用。
 * 后端就绪后可整体移除（_chatSuggestions 接管）。
 */
const COMMON_CAPABILITIES = ['解读结果', '决策建议', '异常诊断', '生成报告'];

export const LOCAL_SUGGESTIONS: Record<string, ModuleSuggestionsVO> = {
  '/abtest/experiment/detail': {
    capabilities: COMMON_CAPABILITIES,
    suggestions: [
      { icon: '📊', text: '解读本实验报告' },
      { icon: '🎯', text: '这个实验能推全吗？' },
      { icon: '⚖️', text: '实验组1 vs 实验组2 哪个更优' },
      { icon: '📝', text: '帮我写实验决策报告' }
    ]
  },
  '/abtest/experiment/detail/reportConfig': {
    capabilities: COMMON_CAPABILITIES,
    suggestions: [
      { icon: '📋', text: '当前报表配置有什么可以优化' },
      { icon: '📊', text: '推荐适合本实验的核心指标' }
    ]
  },
  '/abtest/experiment/smartDetail': {
    capabilities: COMMON_CAPABILITIES,
    suggestions: [
      { icon: '📊', text: '解读当前实验数据' },
      { icon: '⚠️', text: '数据有什么异常' }
    ]
  },
  '/abtest/allExp/expList': {
    capabilities: COMMON_CAPABILITIES,
    suggestions: [
      { icon: '🔍', text: '哪些实验有显著效果？' },
      { icon: '⚠️', text: '近期异常实验排查' },
      { icon: '📈', text: '本月新建实验汇总' }
    ]
  },
  '/abtest/operateReport': {
    capabilities: COMMON_CAPABILITIES,
    suggestions: [
      { icon: '📊', text: '解读当前运营报表' },
      { icon: '⚠️', text: '哪些指标在恶化' }
    ]
  },
  default: {
    capabilities: COMMON_CAPABILITIES,
    suggestions: [
      { icon: '💬', text: '这个页面能做什么？' },
      { icon: '📊', text: '帮我看看当前数据' },
      { icon: '✍️', text: '帮我生成一份总结' }
    ]
  }
};
